<template>
  <nav
    v-if="items?.length"
    class="breadcrumbs"
    aria-label="Breadcrumb"
  >
    <template
      v-for="(item, idx) in items"
      :key="`${item.url}-${idx}`"
    >
      <component
        :is="item.url ? 'router-link' : 'span'"
        :class="['breadcrumb', { 'is-link': !!item.url }]"
        :to="item.url"
      >
        {{ item.name }}
      </component>
      <UIIconComponent
        v-if="idx < items.length - 1"
        class="separator"
        icon="chevron-right"
      />
    </template>
  </nav>
</template>

<script setup lang="ts">
  import type { BreadCrumb } from '@tc8l/nuxt-base'

  defineProps<{
    items?: BreadCrumb[]
  }>()
</script>

<style lang="scss" scoped>
  .breadcrumbs {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  .breadcrumb {
    display: inline-flex;
    align-items: center;
    font-size: 2rem;
  }

  .separator {
    width: 2.4rem;
    height: 2.4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 2rem;
    margin-left: var(--margin-xs);
    margin-right: var(--margin-sm);
  }
</style>
